module.exports = __webpack_public_path__ + "static/rucksack-magazine-386319.3bb1c4e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/rucksack-magazine-386319.jpg
// module id = 333
// module chunks = 221374088121123